module.exports = __webpack_public_path__ + "static/media/Mere-Exposure Effect, Familiarity Principle - mika-baumeister-3KBlVVWwA18-unsplash.5414a240.jpg";